import { Button } from 'ui/mobile-ds';
import { AIStar } from 'ui/icons';
import { FLOATING_WIDGET_Z_INDEX, IFloatingVariantProps } from '../FloatingWidget';

const CultBot = ({ onTriggerClick, isHidden, isOpen }: IFloatingVariantProps) => {
  // No close-state FAB: the widget's own back button closes it (CLOSE_IFRAME).
  if (isHidden || isOpen) {
    return null;
  }

  return (
    <div id="cult-bot-trigger">
      <Button
        style={{ zIndex: FLOATING_WIDGET_Z_INDEX + 1 }}
        prefixIcon={() => <AIStar />}
        className="fixed right-6 bottom-6 outline-none py-3 px-4 rounded-full text-sm shadow-md border-2 border-mobile-gray-100 bg-white hover:bg-secondary-50 active:bg-white focus:bg-secondary-50 text-mobile-gray-500 font-semibold min-w-fit gap-0"
        onClick={onTriggerClick}
      >
        <p className="ml-2">Ask about CultPass</p>
      </Button>
    </div>
  );
};

export default CultBot;
